import { Trans, useTranslation } from "@outschool/localization";
import { pathFromLocation } from "@outschool/routes";
import { gql, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useSession } from "@outschool/ui-auth";
import { useTopNoticeContext } from "@outschool/ui-components-website";
import { Banner } from "@outschool/ui-legacy-component-library";
import React from "react";
import { useLocation } from "react-router-dom";

import { ActivityFragment } from "../../shared/client/fragments/ActivityFragments";
import * as Routes from "../../shared/Routes";
import { SectionFragment } from "../queries/SectionFragments";
import Link from "./Link";

export const REVIEW_REMINDER_QUERY_NAME = "ReviewReminderTopNoticeBar";

export const reviewReminderQuery = gql`
  query ReviewReminderTopNoticeBar {
    currentUser {
      uid
      enrolledSectionThatNeedsReview {
        filledSpaceCount
        ...SectionFragment
        activity {
          ...ActivityFragment
        }
      }
    }
  }
  ${SectionFragment}
  ${ActivityFragment}
`;

export default function ReviewReminderTopNoticeBar() {
  const { topNotice, timedTopNotice } = useTopNoticeContext();
  const hide = !!topNotice || timedTopNotice;
  const { currentUser } = useSession();
  const location = useLocation();
  const { loading, error, data } = useQueryWithPreviousData(
    reviewReminderQuery,
    {
      skip: !!hide || !currentUser
    }
  );
  const { t } = useTranslation(
    "client\\components\\ReviewReminderTopNoticeBar"
  );

  if (hide || !currentUser) {
    return null;
  }
  if (loading || error) {
    return null;
  }
  const { enrolledSectionThatNeedsReview: section = null } =
    (data && data.currentUser) || {};
  if (!section) {
    return null;
  }
  const { activity } = section;
  const feedbackPath = Routes.sectionFeedbackPath(activity, section);
  if (pathFromLocation(location) === feedbackPath) {
    return null;
  }

  const activityTitle = activity.titleTranslated;
  return (
    <Banner>
      <Trans t={t}>
        Please <Link to={feedbackPath}>give feedback</Link> for '
        {{ activityTitle }}'
      </Trans>
    </Banner>
  );
}
